import api from '@/api/'

export const strategyCommand = {
  delete({ id }) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      async onOk() {
        const res = await api.deleteWord({ id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  },
  edit(data) {
    this.title = title.Edit
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      this.form = { ...data }
    })
  }
}

export const title = {
  Add: '添加违禁词',
  Edit: '编辑违禁词'
}
